import { render, staticRenderFns } from "./ListaSpecifiche.vue?vue&type=template&id=55be4c0a&scoped=true&"
import script from "./ListaSpecifiche.vue?vue&type=script&lang=js&"
export * from "./ListaSpecifiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55be4c0a",
  null
  
)

export default component.exports